export default __webpack_public_path__ + "static/hero_img-59f469bb87ebbb898430d4311cfbef45.png";